import { useSyncExternalStore, type ComponentProps } from 'react';
import type { SolverProgressV2 } from '@minglun/protocol';
import { RunPanel, RunningStatus } from './workspace-shell';

export { createProgressStore } from './progress-store';
import type { ProgressStore } from './progress-store';
export function LiveRunPanel({store,...props}:Omit<ComponentProps<typeof RunPanel>,'progress'> & {store:ProgressStore}) {
  const progress=useSyncExternalStore(store.subscribe,store.getSnapshot);
  return <RunPanel {...props} progress={progress}/>;
}
export function LiveRunningStatus({store}:{store:ProgressStore}) {
  const progress=useSyncExternalStore(store.subscribe,store.getSnapshot);
  return progress ? <RunningStatus progress={progress}/> : null;
}
